// extracted by mini-css-extract-plugin
export default {"historySection":"PastMoves_historySection__hWrXd","cardBody":"PastMoves_cardBody__h67uc","listItem":"PastMoves_listItem__GiqKQ","moveList":"PastMoves_moveList__UZ4Kk"};